import { useAppSelector } from '@/store/hooks'

import { selectActiveBuilding } from '../reducers/buildingSelectorReducer'
import { selectUserData } from '../reducers/userDataReducer'

const DEFAULT_MOBILE_APP_NAME = 'The Resident App'

export const useMobileAppName = (): string => {
  const selectedBuilding = useAppSelector(selectActiveBuilding)
  const userData = useAppSelector(selectUserData)

  return selectedBuilding?.appName || userData?.buildingId?.appName || DEFAULT_MOBILE_APP_NAME
}
